module.exports = __webpack_public_path__ + "static/media/phoneme.4cad97b3.png";